import React, { useState } from "react";
import RequestService from "../../services/request.service";

import { toast } from 'react-toastify'

import moment from 'moment'
import 'moment/locale/es'


import { labelType } from '../../features/interfaces'


import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from 'date-fns/locale/es';


import Select from 'react-select';

const FaltasRetardos = () =>{

      const [ reporte, setRegistro ] = useState<any>({
        faltas_lista : [],
        faltas_por_sucursal : [],
      })

      const cargarMiReporte = async () =>{
        try{
          setCargando(true)
            let uuids_sucursales = etiquetas_seleccionadas.map( (sucursal:any)=> sucursal.value )
            var ED = endDate ? moment(endDate).format('YYYY-MM-DD') : null
            let res = await RequestService.getEndPointPost(`reportes/faltas_retardos/${moment(startDate).format('YYYY-MM-DD')}/${ED}`,{ sucursales : uuids_sucursales })
            setRegistro(res.data)
          setCargando(false)

        }
        catch(e){
          setCargando(false)
          toast.error('Problemas cargando')
          toast.error(JSON.stringify(e))
        }
      }



  const [ sucursales, setSucursales ] = useState<any>([])
  const cargarSucursales = async()=>{
    try{
      
      let response : any = await RequestService.getEndPoint('sucursales')
      // let suc : any = response.data
      let sucursales : any = response.data.map( sucursal =>{ return  { value :  sucursal.uuid, label : sucursal.nombre_sucursal } })
      setSucursales(sucursales)
    }
    catch(e){
      toast.error('Problemas al intentar cargar sucursales')
    }
  }


      React.useEffect(() => {
        cargarMiReporte()
        cargarSucursales()
      }, []);

      const defaultValue : labelType[] = []
      const [ etiquetas_seleccionadas, setEtiquetasSeleccionada ] = useState<any>([])
      const [ etiquetas_seleccionadas_, setEtiquetasSeleccionada_ ] = useState<any>([])



  const [ cargando_, setCargando ] = useState( true )



  const [ arreglo_estatus, setEstatus ] = useState<any>([true,true,true,true,true,true,true,true,true,true])


  const todos = () =>{
    setEstatus([true,true,true,true,true,true,true,true,true,true])
  }
  const ninguno = () =>{
    setEstatus([false,false,false,false,false,false,false,false,false,false])
  }




  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());


  const [startDate_, setStartDate_] = useState(new Date());
  const [endDate_, setEndDate_] = useState(new Date());


  const onChangeRango = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
    // cargarMiReporte()
  };


  const [ tipo_reporte, setTipoReporte ] = useState<number>(1)


      return (
          <>

            <div className="container-fluid">

              <div className="row justify-content-center">
                <div className="col-8 col-sm-8">

                    <h4>Faltas y Retardos</h4>
                    <hr/>






                <div className="row">
                    <div className="col">
                      
                        <div className="mb-3">
                            <label className="form-label">Fecha y Hora de la Noticia</label>

                          <DatePicker
                          className="form-control"
                            onChange={onChangeRango}
                            startDate={startDate}
                            endDate={endDate}
                            selectsRange
                            dateFormat="dd-MMM-yyyy"
                          />
                        </div>



                    </div>
                    <div className="col-sm-8">
                      

                    <div className="mb-3">
                      <label className="form-label">Filtro por Sucursal</label>

                          <div className="hstack gap-3">

                              <Select
                                isMulti
                                defaultValue={defaultValue}
                                onChange={(opt:any,e:any)=>{ setEtiquetasSeleccionada(opt) }}
                                isClearable={true}
                                name="colors"
                                options={sucursales}
                                className="basic-multi-select"
                                classNamePrefix="select"
                              />
                                                 

                            <button type="button" onClick={(e:any)=>{cargarMiReporte()}} className="btn btn-secondary">Cargar</button>
                          </div>

                    </div>


                    </div>
                </div>



                <div className="mb-3">
                    <label className="form-label">Tipo de Reporte</label>
                    <div className="form-check form-check-inline">
                      <input className="form-check-input" type="radio" id="inlineCheckbox1" checked={tipo_reporte===1} onChange={(e:any)=>{setTipoReporte(1)}} />
                      <label className="form-check-label" htmlFor="inlineCheckbox1">Reporte por Sucursal </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input className="form-check-input" type="radio" id="inlineCheckbox2" checked={tipo_reporte===2} onChange={(e:any)=>{setTipoReporte(2)}} />
                      <label className="form-check-label" htmlFor="inlineCheckbox2">Reporte por Empleado</label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input className="form-check-input" type="radio" id="inlineCheckbox3" checked={tipo_reporte===3} onChange={(e:any)=>{setTipoReporte(3)}} />
                      <label className="form-check-label" htmlFor="inlineCheckbox3">Listado de Faltas</label>
                    </div>
                </div>



                {
                  !cargando_ && (
                      <>



                        {
                          reporte.faltas_lista.length > 0 && (
                              <>

                                      {
                                        // JSON.stringify(reporte)
                                      }


                                      {
                                        tipo_reporte === 1 && (
                                          <>
                                            {
                                              // JSON.stringify(reporte.faltas_por_sucursal)
                                            }

                                                <table className="table table-hover">
                                                  <thead style={{fontSize:10}}>
                                                    <tr>
                                                      <th className="text-left" scope="col">Sucursal</th>
                                                      <th className="text-center" scope="col">Faltas</th>
                                                      <th className="text-center" scope="col">Faltas Justificadas</th>
                                                      <th className="text-center" scope="col">Retardo</th>
                                                      <th className="text-center" scope="col">Retardo Justificados</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {
                                                      reporte.faltas_por_sucursal.map((sucursal:any)=>
                                                              <tr key={ Math.random().toString(36).substr(2, 9) }>
                                                                <td >
                                                                  <p className="nm">{sucursal.nombre_sucursal}</p>
                                                                </td>
                                                                <td className="text-center" style={{width:80}}>
                                                                  <p className="nm"><small>{sucursal.faltas}</small></p>
                                                                </td>
                                                                <td className="text-center" style={{width:80}}>
                                                                  <p className="nm"><small>{sucursal.faltas_justificadas}</small></p>
                                                                </td>
                                                                <td className="text-center" style={{width:80}}>
                                                                  <p className="nm">{sucursal.retardos}</p>
                                                                </td>
                                                                <td className="text-center" style={{width:80}}>
                                                                  <p className="nm"><small>{sucursal.retardos_justificados}</small></p>
                                                                </td>
                                                              </tr>
                                                        )
                                                    }

                                                  </tbody>
                                                </table>



                                          </>
                                        )
                                      }



                                        

                                      {
                                        tipo_reporte === 2 && (
                                          <>
                                            {
                                              // JSON.stringify(reporte.acumulado_empleados)
                                            }

                                                <table className="table table-hover">
                                                  <thead style={{fontSize:10}}>
                                                    <tr>
                                                      <th className="text-left" scope="col">Empleado</th>
                                                      <th className="text-center" scope="col">Sucursal</th>

                                                      <th className="text-center" scope="col">Faltas</th>
                                                      <th className="text-center" scope="col">Faltas Justificadas</th>
                                                      <th className="text-center" scope="col">Retardo</th>
                                                      <th className="text-center" scope="col">Retardo Justificados</th>

                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {
                                                      reporte.acumulado_empleados.map((empleado:any)=>
                                                              <tr key={ Math.random().toString(36).substr(2, 9) }>
                                                                <td >
                                                                  <p className="nm"><b>{empleado.nombres}</b> {empleado.paterno} {empleado.materno}</p>
                                                                </td>
                                                                <td className="text-left" style={{width:400}}>
                                                                  <p className="nm"><small>{empleado.nombre_sucursal}</small></p>
                                                                </td>
                                                                

                                                                <td className="text-center" style={{width:80}}>
                                                                  <p className="nm"><small>{empleado.faltas}</small></p>
                                                                </td>
                                                                <td className="text-center" style={{width:80}}>
                                                                  <p className="nm"><small>{empleado.faltas_justificadas}</small></p>
                                                                </td>
                                                                <td className="text-center" style={{width:80}}>
                                                                  <p className="nm">{empleado.retardos}</p>
                                                                </td>
                                                                <td className="text-center" style={{width:80}}>
                                                                  <p className="nm"><small>{empleado.retardos_justificados}</small></p>
                                                                </td>



                                                              </tr>
                                                        )
                                                    }

                                                  </tbody>
                                                </table>



                                          </>
                                        )
                                      }



                                        

                                      {
                                        tipo_reporte === 3 && (
                                          <>
                                            {
                                              // JSON.stringify(reporte)
                                            }

                                                <table className="table table-hover">
                                                  <thead style={{fontSize:10}}>
                                                    <tr>
                                                      <th className="text-left" scope="col">Empleado</th>
                                                      <th className="text-center" scope="col">Sucursal</th>
                                                      <th className="text-center" scope="col">Tipo</th>
                                                      <th className="text-center" scope="col">Justificado</th>
                                                      <th className="text-center" scope="col">Fecha</th>
                                                    </tr>
                                                  </thead>
                                                  <tbody>
                                                    {
                                                      reporte.faltas_lista.map((empleado:any)=>
                                                              <tr key={ Math.random().toString(36).substr(2, 9) }>
                                                                <td >
                                                                  <p className="nm"><b>{empleado.nombres}</b> {empleado.paterno} {empleado.materno}</p>
                                                                </td>
                                                                <td className="text-left" style={{width:400}}>
                                                                  <p className="nm"><small>{empleado.nombre_sucursal}</small></p>
                                                                </td>
                                                                <td className="text-left" style={{width:120}}>
                                                                  <p className="nm"><small>{empleado.retardo?'RETARDO':'FALTA'}</small></p>
                                                                </td>
                                                                <td className="text-center" style={{width:120}}>
                                                                  <p className="nm"><small>{empleado.justificada?'SI':''}</small></p>
                                                                </td>
                                                                <td className="text-center" style={{width:120}}>
                                                                  <p className="nm"><small>{empleado.fecha}</small></p>
                                                                </td>
                                                              </tr>
                                                        )
                                                    }

                                                  </tbody>
                                                </table>


                                          </>
                                        )
                                      }



                              </>
                            )
                        }


                      </>
                    )
                }

                    
                </div>
              </div>

            </div>

          </>

      );
  

}

export default FaltasRetardos
